import { isEmpty, isNil, omitBy } from 'lodash';
/**
 * url 拼接参数
 * @param url
 * @param params
 * @param updateParams
 * @returns
 */
export const appendParams = (url: string, params: any, updateParams?: any) => {
  if (params) {
    let result = url;
    if (!url.includes('?')) {
      result += '?';
    }
    const preFix = Object.keys(params).map((e, i) => {
      const splitArr = result.split('?');
      if (result.includes('?') && !splitArr?.[1] && i === 0) {
        return `${e}=${params[e]}`;
      }
      return `&${e}=${params[e]}`;
    });
    const one = result + preFix.join('');
    if (!isEmpty(updateParams)) {
      const path = one.split('?')[0];
      const originParams = getQueryParams(one);

      const allParams = { ...originParams, ...updateParams };
      const endParams = Object.keys(allParams)
        .map(e => `${e}=${allParams[e]}`)
        .join('&');

      const endUrl = endParams ? `${path}?${endParams}` : path;
      return endUrl;
    }
    return one;
  }
  return url;
};

const getQueryParams = (url: string) => {
  const queryString = url.split('?')[1];
  if (!queryString) {
    return {};
  }

  const queryParams = queryString.split('&').reduce((params: any, param) => {
    const parts = param.split('=');
    params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
    return params;
  }, {});

  return queryParams;
};

/**
 * 修改url参数
 * @param url
 * @param params
 * @returns
 */
export const changeParams = (url: string, params: any) => {
  if (params) {
    const entries = Object.entries(omitBy(params, isNil));
    let result = url;
    if (!url.includes('?')) {
      result += '?';
    }
    return entries.reduce(
      (result, [key, value]) => [result, `${key}=${value}`].filter(Boolean).join('&'),
      result,
    );
  }
  return url;
};
